import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import './style.scss';

export class ContactUserEmail {
    summernoteOptions = {
        defaultFontName: 'Arial',
        toolbar: [
            ['style', ['bold', 'italic', 'underline']],
            ['alignment', ['ul']],
            ['insert', ['ltr', 'rtl']],
        ],
        callbacks: {
            onInit(summernote) {
                const $noteEditor = $('.note-editor');

                summernote.toolbar.hide();
                $(window)
                    .on('click.Bst', (event) => {
                        const needToHide = $noteEditor.has(event.target).length === 0 && !$noteEditor.is(event.target);

                        if (needToHide) {
                            summernote.toolbar.hide();
                        }
                    });
                summernote.editable.focus(() => summernote.toolbar.show());
            },
        },
    };

    selectedTemplate = null;

    templateOptions = [];

    selectedEmails = [];

    $onChanges() {
        this.setEmailData(this.emailData);
    }

    setEmailData({ templates, emailsTo } = {}) {
        this.setTemplateOptions(templates);
        this.setEmails(emailsTo);
    }

    setTemplateOptions(templates) {
        this.templateOptions = (templates || []).map(template => ({
            label: template.name,
            value: template,
        }));

        if (this.templateOptions.length > 0) {
            this.selectedTemplate = this.templateOptions[0].value;
        }
    }

    setEmails(emailsTo) {
        this.allEmails = emailsTo;
        this.selectedEmails = (emailsTo || []).filter(({ isSelected }) => isSelected);
    }

    onSelectedTemplateChange({ value }) {
        this.selectedTemplate = value;
    }

    onSelectedEmailsChanged(selectedEmails) {
        this.selectedEmails = selectedEmails;
    }

    onSend() {
        const email = this.getEmailData();

        this.onSendEmail({ email });
    }

    getEmailData() {
        const to = (this.selectedEmails || []).map(({ value }) => value);
        const { subject, template: content } = this.selectedTemplate;

        return {
            to,
            subject,
            content,
        };
    }
}

export const ContactUserEmailConfiguration = {
    template,
    bindings: {
        emailData: '<',
        onSendEmail: '&',
        onCancel: '&',
    },
    controller: ContactUserEmail,
    controllerAs: 'contactUserEmailCtrl',
};

angular.module('TALENYA-FE')
    .component('contactUserEmail', ContactUserEmailConfiguration);